import { createSlice } from "@reduxjs/toolkit";

const eventSlice = createSlice({
  name: "eventDetails",
  initialState: {
    id: null,

    exercise: null,
  },
  reducers: {
    updateEventDetails: (state, action) => {
      const { id, exercise } = action.payload;

      state.id = id;
      state.exercise = exercise;
    },
  },
});

export const { updateEventDetails } = eventSlice.actions;

export default eventSlice.reducer;
